import { gql } from '@apollo/client';

const createOneCourseMetricDefinitionMutation = gql`
  mutation CreateOneCourseMetricDefinition($record: CourseMetricDefinitionInput!) {
    createOneCourseMetricDefinition(record: $record) {
      record {
        _id
        key
        order
        uiType
      }
    }
  }
`;

export default createOneCourseMetricDefinitionMutation;
